import React from 'react';
import './ITSoftware.css';

function ManufacturingEngineering() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/manifacturing&engineering1.png')" }}
      >
        <div className="hero-text-container">
          <h1>Manufacturing & Engineering</h1>
          <p>Boosting operational efficiency, compliance, and growth in core industrial sectors</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Powering production with financial precision.</h2>
          <p>Our team works with MSMEs and large manufacturers to optimize financial systems, cost structures, and regulatory frameworks.</p>
          <p>We guide businesses in implementing ERP systems, managing GST intricacies, and building export strategies.</p>
          <p>From factory setup to lean finance models, we help align operational and financial performance for maximum output.</p>
          <p>Whether you operate in heavy engineering or small component assembly, our services help reduce overhead and improve profitability.</p>
        </div>
        <div className="content-right">
          <img src="/images/manufacturing.jpg" alt="Manufacturing & Engineering" />
        </div>
      </section>
    </div>
  );
}

export default ManufacturingEngineering;
